import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import {errorlist} from '../providers/errorlist';
import { Forgot } from '../models/user';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  public forgotPasswordData: Forgot = {email: null};
  errorlist:any;
  constructor(private auth : AuthService, private router: Router, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.forgotPasswordData = {
      email:""
    }
    this.errorlist = errorlist;
  }

  forgotpasswordUser():void{
    console.log(this.forgotPasswordData)
    this.spinnerService.show();
    this.auth.forgot_password(this.forgotPasswordData).then((user) => {
      console.log(user.json());
      let response = user.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.forgotPasswordData = {};
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
        this.router.navigateByUrl('/');
      }
    })
    .catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/forgot-password/forgot-password.component.ts